import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { bool, func, array } from 'prop-types';
import styled from 'styled-components';
import { Icon, constants } from '@ifixit/toolbox';

const { animation, transition, color, spacing, fontSize } = constants;
const { dropdownOpen, dropdownClose } = animation;
const timeout = 140;

const Button = styled.div`
   display: flex;
   align-items: center;
   height: 50px;
   padding: 0 ${spacing[1]};
   cursor: pointer;

   &:hover {
      color: ${color.blue[4]};
   }
`;

const A = styled.a`
   &:hover {
      text-decoration: none;
   }
`;

const Dropdown = styled.div`
   z-index: 4;
   position: absolute;
   display: ${props => (props.isOpen ? 'flex' : 'none')};
   flex-direction: column;
   top: ${spacing[6]};
   left: ${spacing[3]};
   min-width: 160px;
   background: ${color.white};
   border: 1px solid ${color.grayAlpha[3]};
   border-radius: 4px;
   box-shadow: 0 15px 30px ${color.grayAlpha[3]};
   animation: ${props => (props.isClosing ? dropdownClose : dropdownOpen)} ${transition.duration};
`;

const DropdownItem = styled.h3`
   margin: 0;
   padding: ${spacing[3]};
   color: ${color.black};
   font-size: ${fontSize[1]};
   font-weight: normal;
   transition: background-color 0.1s ${transition.easing};

   &:hover {
      background-color: ${color.grayAlpha[2]};
   }
`;

const translation = '-10%';

class OverflowDropdown extends Component {
   state = {
      isOpen: false,
      isClosing: false,
   };

   toggleDropdown = () => {
      if (this.state.isOpen) {
         this.animateClosed();
      } else {
         this.setState({ isOpen: !this.state.isClosing });
      }
   };

   animateClosed() {
      this.setState({
         isOpen: false,
         isClosing: true,
      });

      setTimeout(() => {
         this.setState({ isClosing: false });
      }, timeout);
   }

   // Closes the dropdown if anywhere outside the dropdown is clicked.
   handleOutsideClick = event => {
      if (!this.state.isOpen) {
         return;
      }

      const domNode = ReactDOM.findDOMNode(this);

      if (!(domNode && domNode.contains(event.target))) {
         this.animateClosed();
      }
   };

   componentDidMount() {
      document.addEventListener('click', this.handleOutsideClick, true);
   }

   componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick, true);
   }

   render() {
      const { items } = this.props;

      return (
         <div>
            <Button onClick={this.toggleDropdown}>
               <Icon color={color.gray[6]} name="more-horizontal" />
            </Button>
            <Dropdown
               isOpen={this.state.isOpen || this.state.isClosing}
               isClosing={this.state.isClosing}
            >
               {items.map((item, index) => (
                  <A key={index} textDecoration="none !important" href={item.url}>
                     <DropdownItem>{item.title}</DropdownItem>
                  </A>
               ))}
            </Dropdown>
         </div>
      );
   }
}

OverflowDropdown.propTypes = {
   items: array,
};

OverflowDropdown.defaultProps = {
   items: [],
};

export default OverflowDropdown;
